import React from "react";
import { NavLink } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { useFetch, useLanguage } from "hooks";
import {
  ScrollList,
  BookCard,
  AuthorCard,
  TabSlider,
  Icons,
  Skeletons
} from "components";

/*
there are 3 tabs Most searched subjects, Most searched authors, Most searched Books
to call its data you should to send the tab number to the api 
*/

function ContentSlider() {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const [currentTab, setCurrentTab] = React.useState(1);
  const [tabResponse, tabRequest] = useFetch(
    `getHomeTabsData?type=${currentTab}`
  );

  const Tabs = [
    {
      title: language.mostSearchingBooks,
    },
    {
      title: language.mostSearchedAuthors,
    },
    {
      title: language.topRatedBooks,
    },
  ];

  React.useEffect(() => {
    tabRequest();
  }, [tabRequest]);

  return (
    <section className="mb-3 content-slider">
      {/* Tabs Buttons */}
      <Container>
        <TabSlider
          tabs={Tabs}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
        />

        {/* Card Slider */}
        <Row className="slider_area mb-4  mb-sm-4">
          <Col xs={12}>
            {!tabResponse.loading && tabResponse.result.data ? (
              <ScrollList
                xs={{
                  slidesPerView: 1,
                  pagination: { clickable: true },
                }}
                sm={{
                  slidesPerView: 2,
                  pagination: { clickable: true },
                }}
                lg={{
                  slidesPerView: 3,
                }}
                xl={{
                  slidesPerView: 4,
                }}
                itemAs={
                  tabResponse.result.data.component === 2
                    ? AuthorCard
                    : BookCard
                }
                items={tabResponse.result.data.data}
                autoplay
                loop
              />
              // component 2 for AuthorCard to show the authors 
            ) : (
              <Skeletons.CardsSkeleton count={4} perRow={4} />
            )}
          </Col>
        </Row>

        {/* Discover More Button page that show all the data in the slider */}
        <Row className="discover_link d-flex align-items-center px-4">
          <Col xs={12}>
            <NavLink to={`discover/${currentTab}`}>
              <p
                className="fw-bold text-secondary d-block"
                style={{ bottom: "4px" }}
              >
                {language.discover}
              </p>
              <Icons.ArrowLeft />
            </NavLink>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
export default ContentSlider;
